import * as React from "react";
import { Link } from "react-router-dom";
import SecretStore from "../../../../stores/SecretStore";
import { GetSecretList } from "../../../../actions/SecretActions";
class SecretSidebar extends React.Component {
  //isList: Array<BPModel>;
  constructor(props) {
    super(props);
    this.state = {
      secretList: [],
      secretsLoaded: false
    };
    this.onReceiveSecretChange = this.onReceiveSecretChange.bind(this);
  }
  componentDidMount() {
    SecretStore.addChangeListener(this.onReceiveSecretChange);
    GetSecretList();
  }
  componentWillUnmount() {
    SecretStore.removeChangeListener(this.onReceiveSecretChange);
  }
  onReceiveSecretChange() {
    let lastChange = SecretStore.lastChange();
    if (lastChange === "SecretList") {
      let secrets = SecretStore.getSecrets();
      this.setState({
        secretList: secrets,
        secretsLoaded: true
      });
    }
  }
  render() {
    let listOfSecrets;
    if (this.state.secretList !== void 0) {
      listOfSecrets = this.state.secretList.map((secret) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "8px" }, key: secret.id }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/SecretView/" + secret.id,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        secret.isEncrypted ? /* @__PURE__ */ React.createElement("i", { style: { color: "#FFD700" }, className: "fa-solid fa-key", title: "Encrypted" }) : /* @__PURE__ */ React.createElement("i", { title: "UnEncrypted", style: { color: "#86AFC0" }, className: "fa-solid fa-key" }),
        " ",
        secret.name
      )));
    } else {
      listOfSecrets = /* @__PURE__ */ React.createElement("div", null, "No secrets defined");
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "245px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/Secret",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement("i", { style: { color: "#FFCA48" }, className: "fa-solid fa-key" }), "   ", "Secrets")
      ),
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/SystemAuditLogs/Admin/Secrets",
          style: { textDecoration: "none", color: "White", display: "inline-block", target: "_blank" }
        },
        /* @__PURE__ */ React.createElement("div", { className: "navSubHeader" }, /* @__PURE__ */ React.createElement("span", { style: { color: "#BE4EE8" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-table" })), " ", "Audit Page")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "50%", overflow: "auto" } }, listOfSecrets),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/SecretView/0" }, "New Secret")
    );
  }
}
export default SecretSidebar;
